const abandonedCart = require('./abandonedCart');

/**
 * Initialize all analytics clients
 */
function init() {
    abandonedCart.init();
}

module.exports = {
    init
};
